import { MenuItem, styled } from "@mui/material";

export const MenuItemStyled = styled(MenuItem)(({ theme }) => ({
  "&.Mui-selected": {
    color: theme.palette.primary.main,
  },
}));
